import * as types from "../types/index";
import { setInitialState } from "../InitialState";


const INITIAL_STATE = setInitialState({
    data: null,
});

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.USER_PROFILE_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.USER_PROFILE_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                data: action.payload.success
            };
        case types.USER_PROFILE_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                data: action.payload.response,
            };
        case types.RESET_USER_PROFILE:
            return {
                ...state,
                isFetching: false,
                isError: false,
                data: null,
            };
        default:
            return {
                ...state
            }
    }
}